/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_register_button_creating_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating account...`)
};

const zh_hans1_register_button_creating_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在创建账户...`)
};

const zh_hant1_register_button_creating_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在建立帳戶…`)
};

const fr_register_button_creating_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création du compte...`)
};

const de_register_button_creating_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto wird erstellt...`)
};

const ja_register_button_creating_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウント作成中…`)
};

const ko_register_button_creating_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정 생성 중...`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register_button_creating_account = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register_button_creating_account(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register_button_creating_account", locale)
	if (locale === "en") return en_register_button_creating_account(inputs)
	if (locale === "zh-Hans") return zh_hans1_register_button_creating_account(inputs)
	if (locale === "zh-Hant") return zh_hant1_register_button_creating_account(inputs)
	if (locale === "fr") return fr_register_button_creating_account(inputs)
	if (locale === "de") return de_register_button_creating_account(inputs)
	if (locale === "ja") return ja_register_button_creating_account(inputs)
	return ko_register_button_creating_account(inputs)
};